import React, { useState } from "react";
import { Box } from "@mui/material";
import FileUpload from "../FileUpload/FileUpload";


interface ActionPayload {
  text: string;
  payload: string;
}

interface ActionListProps {
  actionList: { payload: ActionPayload[] };
}
  //@ts-ignore

const RichMediaUpload = ( actionList ) => {
  const [uploadedFile, setUploadedFile] = useState(null);
  console.log(actionList.payload[0].payload);

  const handleFileSelect = (file: File | null) => {
      //@ts-ignore
    setUploadedFile(file);
    console.log("Uploaded File:", uploadedFile);
  };

  return (
    <Box sx={{
      display: "flex",
      flexFlow: "column",
      width: "auto",
      textAlign: "left",
      background: "#e5e5ea",
      padding: "12px",
      borderRadius: "12px",
      margin: "12px 12px 0 30px",
      maxWidth: "fit-content"

  }}>
    <h3 style={{ marginBottom: "20px" }}>Please upload your deposit slip</h3>
        <FileUpload onFileSelect={handleFileSelect} />
    </Box>
  );
};
export default RichMediaUpload;
